module.exports = __webpack_public_path__ + "static/media/navori-labs-mobile.ff3e5856.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/navori-labs-mobile.jpg
// module id = 56
// module chunks = 0